(() => {
  const form = document.getElementById('LcLanguageForm');
  const select = form?.querySelector('[data-lc-language]');
  if (!select) return;
  const current = document.documentElement.lang.split('-')[0];
  const available = [...select.options].map(option => option.value);
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  form.addEventListener('submit', () => { write('localStorage', 'lc-language-choice', select.value); write('sessionStorage', 'lc-language-checked', '1'); });
  select.addEventListener('change', () => form.requestSubmit());
  if (window.Shopify?.designMode) return;
  const saved = read('localStorage', 'lc-language-choice');
  if (!saved && read('sessionStorage', 'lc-language-checked')) return;
  write('sessionStorage', 'lc-language-checked', '1');
  const explicitArabicUrl = /^\/ar(?:\/|$)/.test(location.pathname);
  const preferred = saved || (explicitArabicUrl ? 'ar' : (navigator.languages || [navigator.language]).map(value => value.split('-')[0]).find(value => available.includes(value)));
  if (preferred && preferred !== current && available.includes(preferred)) {
    const attempt = preferred + ':' + location.pathname;
    if (read('sessionStorage', 'lc-language-attempt') === attempt) return;
    write('sessionStorage', 'lc-language-attempt', attempt);
    select.value = preferred;
    HTMLFormElement.prototype.submit.call(form);
  }
})();
